import styles from "./input.module.scss";
import {
  FieldValues,
  Path,
  PathValue,
  useController,
  UseControllerProps
} from "react-hook-form";
import {
  HTMLInputAutoCompleteAttribute,
  HTMLInputTypeAttribute,
  KeyboardEvent,
  ClipboardEvent
} from "react";

type InputProps<T extends FieldValues> = {
  type?: HTMLInputTypeAttribute;
  disabled?: boolean;
  error?: string;
  autoComplete?: HTMLInputAutoCompleteAttribute;
  maxLength?: number;
  placeholder?: string;
} & UseControllerProps<T>

export const Input = <T extends FieldValues>({ disabled, control, name, error, autoComplete, maxLength, type, placeholder }: InputProps<T>) => {
  const {
    field: { ...inputControl },
  } = useController({
    name,
    control,
    defaultValue: "" as PathValue<T, Path<T>>
  });

  const onlyInteger = (event: KeyboardEvent<HTMLInputElement>) => {
    if (type === "number") {
      if (!/[0-9]/.test(event.key) && event.key !== "Backspace" && event.key !== "Delete") {
        event.preventDefault();
      }
    }
  }
  const pasteInteger = (event: ClipboardEvent<HTMLInputElement>) => {
    if (type === "number") {
      let paste = event.clipboardData.getData('text');
      if (/[^0-9]/.test(paste)) {
        event.preventDefault();
      }
    }
  }

  return (
    <div className={styles.container}>
      <input type="text"
             className={error ? styles.error : ""}
             autoComplete={autoComplete}
             onKeyPress={onlyInteger}
             placeholder={placeholder}
             onPaste={pasteInteger}
             maxLength={maxLength}
             {...inputControl}
             disabled={disabled}/>
      {error && <p className={styles.errorMessage}> {error}</p>}
    </div>
  )
}
